import { setConfig } from './config';
import { Orchestrator } from './orchestrator';
import type { OpenArgs, OpenOptions, QuarterzipAPI, QuarterzipConfig } from './types';

const orchestrator = new Orchestrator();

/**
 * Start (or switch) a call. Call this from a user gesture.
 * @param args   Agent, workspace token, end-user identity, and lifecycle callbacks via `on`.
 * @param options Optional per-call overrides (frame URL, PiP on/off).
 */
export const open = (args: OpenArgs, options?: OpenOptions): void =>
	orchestrator.open(args, options);

/** Close the active call and remove all iframes / PiP windows. Safe to call when nothing is open. */
export const close = (): void => orchestrator.close();

/** Set global defaults merged into every subsequent `open()`. */
export const configure = (config: QuarterzipConfig): void => setConfig(config);

/**
 * Open the floating PiP window. Optional — it appears on its own when the user switches tabs.
 * Call synchronously from a click handler on your page; see {@link QuarterzipAPI.openPip}.
 */
export const openPip = (): void => orchestrator.openPip();

/** Close the floating PiP window; the call continues in the on-page frame. */
export const closePip = (): void => orchestrator.closePip();

export const Quarterzip: QuarterzipAPI = {
	open,
	close,
	configure,
	openPip,
	closePip
};

export type {
	CallCloseEvent,
	CallErrorEvent,
	EventHandlers,
	LogLevel,
	OpenArgs,
	OpenOptions,
	QuarterzipAPI,
	QuarterzipConfig,
	QuarterzipUser
} from './types';

export type { CallEndReason, CallErrorCode } from './protocol';
